import React from 'react';
export function ComparativeReportIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7a6 6 0 01-9.477 4.89l-1.632 1.633a6 6 0 11-1.414-1.414l1.632-1.632A6 6 0 1123 7zM7 21a4 4 0 100-8 4 4 0 000 8z"
  }));
}